import type {
  Filter,
  HotelCategoryFilter,
  HotelRatingFilter,
  OptionFilterItem,
  StaticFilters,
} from '@/modules/common/models/filters';

import {
  FILTER_DEPARTURE_TIME,
  FILTER_HOTEL_CATEGORY,
  FILTER_HOTEL_RATING,
  FILTER_PRICE,
  FILTER_PRICE_CHART,
  FILTER_RETURN_TIME,
} from '@/modules/common/models/filters';

type ExcludedFilters = HotelCategoryFilter | StaticFilters | HotelRatingFilter;
const EXCLUDED_FILTERS = new Set<string>([
  FILTER_PRICE,
  FILTER_HOTEL_CATEGORY,
  FILTER_HOTEL_RATING,
  FILTER_DEPARTURE_TIME,
  FILTER_RETURN_TIME,
  FILTER_PRICE_CHART,
]);

export type Item = OptionFilterItem & {
  filter: {
    id: string;
    setValue: (value: any) => void;
    options: Array<OptionFilterItem>;
  };
};

export const getFiltersForSearch = (filters: Array<Filter>): Array<Item> => {
  return filters
    .filter(
      (filter): filter is Exclude<Filter, ExcludedFilters> =>
        filter.available && !EXCLUDED_FILTERS.has(filter.id)
    )
    .flatMap((item) => {
      return item.options.map((option) => ({
        ...option,
        filter: {
          id: item.id,
          setValue: item.setValue,
          options: item.options,
        },
      }));
    });
};
